import { Button } from "antd";
import styled from "styled-components";
import SocialSection from "../../components/Common/SocialSection";

const ThreeBanners = () => {
  return (
    <Container>
      <ContentWrapper>
        <MainContainer>
          <MainImage src="/webImg/main-img.jpg" />
          <SubContainer>
            <SubBox>
              <SubImage src="https://i.ibb.co/BHCSBKQy/S-35913756.jpg" />
              <DetailBox>
                <TitleSubBox>CREATION 2026 — More Than a Theory!</TitleSubBox>
                <div style={{ display: "flex", gap: "10px" }}>
                  <a
                    rel="noreferrer"
                    style={{ flex: 1 }}
                    target="_blank"
                    href="https://forms.gle/EBm8ZAvV26Kdfeou7"
                  >
                    <Button
                      type="primary"
                      style={{ width: "100%" }}
                      shape="round"
                    >
                      <div>สมัครเลย</div>
                    </Button>
                  </a>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.su-thailand.org/activities?actNo=33"
                  >
                    <Button
                      type="primary"
                      style={{
                        flex: 1,
                        background: "white",
                        color: "#1976FD",
                        border: "1px solid #1976FD",
                      }}
                      shape="round"
                    >
                      <div>รายละเอียด</div>
                    </Button>
                  </a>
                </div>
              </DetailBox>
            </SubBox>
            <SubBox>
              <SubImage src="https://i.ibb.co/HDVtyZ7J/813715143-1380274464308949-3700003655852578331-n.jpg" />
              <DetailBox>
                <TitleSubBox>THE CREATOR OF ALL THINGS</TitleSubBox>
                <div style={{ display: "flex", gap: "10px" }}>
                  <a
                    rel="noreferrer"
                    style={{ flex: 1 }}
                    target="_blank"
                    href="https://forms.gle/rLLhFGenajcCusVh7"
                  >
                    <Button
                      type="primary"
                      style={{ width: "100%" }}
                      shape="round"
                    >
                      <div>สมัครเลย</div>
                    </Button>
                  </a>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.su-thailand.org/activities?actNo=32"
                  >
                    <Button
                      type="primary"
                      style={{
                        flex: 1,
                        background: "white",
                        color: "#1976FD",
                        border: "1px solid #1976FD",
                      }}
                      shape="round"
                    >
                      <div>รายละเอียด</div>
                    </Button>
                  </a>
                </div>
              </DetailBox>
            </SubBox>
            
          </SubContainer>
        </MainContainer>

        <SocialSection />
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  display: flex;
  justify-content: center;

  @media (max-width: 600px) {
    padding: 20px;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const MainContainer = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
`;

const MainImage = styled.img`
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
`;

const SubImage = styled.img`
  border-radius: 8px;
  max-width: 140px;
  width: auto;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

const SubBox = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  background-image: linear-gradient(to top, #046aaf 0%, #04befe 100%);
  gap: 10px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const DetailBox = styled.div`
  background: white;
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
  justify-content: space-between;
`;

const TitleSubBox = styled.div`
  font-size: 16px;
`;

export default ThreeBanners;
